module.exports = __webpack_public_path__ + "img/DOT4.447b2a5a.png";